/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { getCollectionReference } from 'services'
import { collectionNames } from 'constant'

export const getChatReportedData = ({ limit }: any) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const results: any = []

      /** Create a ref collection for thread messages */
      const threadMessagesRef = await getCollectionReference(
        collectionNames.THREAD_MESSAGES,
      )

      /** Create a ref collection for user */
      const usersRef = await getCollectionReference(
        collectionNames.USERS,
      )

      const threadSnapshot = await threadMessagesRef
        .where('reports_count', '>', 0)
        .limit(limit + Number(10))
        .get();

      if (threadSnapshot.size > 0) {
        await Promise.all(
          threadSnapshot.docs.map(async (thread: any) => {
            const threadId = thread.id;
            const threadData = thread.data();
            const users: any = [];
            const userIds = threadData.reports

            await Promise.all(
              userIds.map(async (userId: string) => {
                const userSnapshot = await usersRef.where('uid', '==', userId)
                  .get();

                if (!userSnapshot.empty) {
                  const doc: any = userSnapshot.docs[0].data();
                  users.push(doc.username)
                }
              })
            )

            results.push({
              ...threadData,
              documentId: threadId,
              reported_by_users: users
            })
          })
        )

        resolve({
          chats: results,
          limit: limit + Number(40),
          hasDataToLoad: true,
        })
      } else {
        resolve({
          chats: results,
          limit: limit + Number(40),
          hasDataToLoad: false,
        })
      }
    } catch (error) {
      console.log('getChatReportedData | error', error)
      reject(error)
    }
  })
}

export const setHiddenMessage = (chat: any) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      /** Create a ref collection of thread messages */
      const threadMessagesRef = await getCollectionReference(collectionNames.THREAD_MESSAGES)
      const hidden = !chat.hidden

      threadMessagesRef.doc(chat.documentId).update({ hidden })
      chat.hidden = hidden
      resolve({ success: true, chat })
    } catch (error) {
      console.log('setCollectionInactive | error', error)
      reject(error)
    }
  });
}